.sc-banner {
  background-color: var(--sc-color-brand-primary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;

  > p {
    font-size: 14px;
    line-height: 1;
    margin: var(--sc-spacing-small);

    a {
      color: inherit;
      font-weight: 600;
      margin-left: 10px;
      display: inline-flex;
      align-items: center;
      gap: 8px;
      text-decoration: none;
      border-bottom: 1px solid;
      padding-bottom: 2px;
    }
  }
}
